import { create } from "zustand"
import { immer } from "zustand/middleware/immer"
import type { CommunityUser } from "../types"

interface UserStoreState {
  entities: Record<string, CommunityUser>
  /** Maps alias keys (e.g. "u-self") to real user IDs */
  aliases: Record<string, string>
}

interface UserStoreActions {
  upsertUser: (user: CommunityUser) => void
  upsertUsers: (users: CommunityUser[]) => void
  upsertAlias: (alias: string, realId: string) => void
  updateUser: (id: string, patch: Partial<CommunityUser>) => void
  removeUser: (id: string) => void
  clearUsers: () => void
  /** Resolve an alias or pass-through a real ID */
  resolveId: (key: string) => string
}

export const useUserStore = create<UserStoreState & UserStoreActions>()(
  immer((set, get) => ({
    entities: {},
    aliases: {},
    upsertUser: (user) => set((state) => { state.entities[user.id] = user }),
    upsertUsers: (users) => set((state) => { for (const user of users) { state.entities[user.id] = user } }),
    upsertAlias: (alias, realId) => set((state) => { state.aliases[alias] = realId }),
    updateUser: (id, patch) => set((state) => { const existing = state.entities[id]; if (existing) { Object.assign(existing, patch) } }),
    removeUser: (id) => set((state) => { delete state.entities[id] }),
    clearUsers: () => set((state) => { state.entities = {}; state.aliases = {} }),
    resolveId: (key) => get().aliases[key] ?? key,
  }))
)
